import { HeadingModule, PopoverModule, SharedDirectivesModule } from '@agingplan';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { ReadMoreComponent } from './read-more/read-more.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      meta: {
        title: 'Agingplan',
        description: 'Our sole focus is, and always has been, Long-Term Care planning.',
        standard: {
          keywords: ['Agingplan', 'Long-Term Care', 'planning', 'care', 'insurance'],
        },
      },
    },
  },
];

@NgModule({
  declarations: [HomeComponent, ReadMoreComponent],
  exports: [RouterModule],
  imports: [CommonModule, RouterModule.forChild(routes), PopoverModule, HeadingModule, SharedDirectivesModule],
})
export class HomeModule {}
